import { render, staticRenderFns } from "./Operaciones.vue?vue&type=template&id=5b6ab9e2&scoped=true"
import script from "./Operaciones.vue?vue&type=script&lang=js"
export * from "./Operaciones.vue?vue&type=script&lang=js"
import style0 from "./Operaciones.vue?vue&type=style&index=0&id=5b6ab9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ab9e2",
  null
  
)

export default component.exports